export default __webpack_public_path__ + "static/5-551fdaa1fca831736fd8526962eb1942.jpg";